export default __webpack_public_path__ + "static/media/explain_avatar.ca0ddd78.gif";